import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export const CategoryTag = ({ className = '', to, children }) => {
   return (
      <Link
         to={to}
         style={{
            textDecoration: 'none',
            color: 'white',
         }}
      >
         <div className={`item-tag ${className}`}>{children}</div>
      </Link>
   )
}

export default CategoryTag
